import React, { useEffect } from 'react';

export type SupportAttachmentPreviewState = {
  alt: string;
  src: string;
  title: string;
};

export default function SupportAttachmentPreview({
  onClose,
  preview,
}: {
  onClose: () => void;
  preview: SupportAttachmentPreviewState | null;
}) {
  useEffect(() => {
    if (!preview) return undefined;

    function handleKeyDown(event: KeyboardEvent) {
      if (event.key === 'Escape') onClose();
    }

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [onClose, preview]);

  if (!preview) return null;

  return (
    <div className="sd-attachment-preview-overlay" role="dialog" aria-modal="true" aria-label="Attachment preview">
      <button className="sd-attachment-preview-backdrop" onClick={onClose} type="button" aria-label="Close attachment preview" />
      <div className="sd-attachment-preview-modal">
        <header>
          <div>
            <span>Attachment Preview</span>
            <strong>{preview.title}</strong>
          </div>
          <button onClick={onClose} type="button">Close</button>
        </header>
        <div className="sd-attachment-preview-frame">
          <img src={preview.src} alt={preview.alt} />
        </div>
      </div>
    </div>
  );
}
